import { render, staticRenderFns } from "./BtnAceitar.vue?vue&type=template&id=49827db6"
import script from "./BtnAceitar.vue?vue&type=script&lang=js"
export * from "./BtnAceitar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports